'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('react');
var useFormState = require('../hooks/useFormState.js');

// eslint-disable-next-line no-unused-vars
var FormStateAccessor = function FormStateAccessor(_ref) {
  var children = _ref.children;
  var formState = useFormState.useFormState();
  return children(formState);
};

exports.FormStateAccessor = FormStateAccessor;
